import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SitePickerComponent } from "./site-picker.component";

@NgModule({
  declarations: [SitePickerComponent],
  exports: [SitePickerComponent],
  imports: [
    CommonModule,
    TranslateModule,
  ],
})
export class SitePickerModule {}
